import React from 'react';
import { Box, Button } from '@mui/material';
import './RequestSubTitle.css'; // You'll need to create this CSS file
import { useTranslation } from 'react-i18next';

export default function RequestSubTitle({
    title,
    path,
    cardValue,
    cardtitle,
    buttonText,
    onButtonClick
}) {
    const { t } = useTranslation()
    // Function to format path segments
    const formatPath = (path) => {
        // Split the path into segments
        const segments = path ? path.split('>') : [];

        // Format each segment and join with '>'
        return segments
            .map(segment => t(segment.trim()))
            .join(' > ');
    };

    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        }
    };

    return (
        <div className="request-subtitle-container">
            <div className="request-subtitle-left">
                <Box>
                    <span className="request-subtitle-title">{t(title)}</span>
                    <span className="request-subtitle-path">{formatPath(path)}</span>
                </Box>
            </div>

            <div className="request-subtitle-right">
                {/* Card on the right side */}
                <div className="request-subtitle-card">
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        textAlign: "center",
                        gap: "10px"
                    }}>
                        <span style={{
                            fontFamily: "Roboto",
                            fontWeight: 500,
                            fontSize: "20px",

                        }}>
                            {t(cardtitle)}
                        </span>
                        <span style={{ fontSize: "32px" }}>
                            {cardValue}
                        </span>
                    </div>
                </div>

                {/* Single button */}
                <button
                    className="request-subtitle-button"
                    variant="contained"
                    onClick={handleButtonClick}
                >
                    {t(buttonText)}
                </button>
            </div>
        </div>
    );
}